import convertFormData from '@module/utils/convertFormData';
import { fetchExtended } from '../../../utils/fetch/client-fetch';
import type { IPolicyInfo, PolicyInfoParams } from './type';

export const PolicyInfo = async (policeCheckParams: PolicyInfoParams) => {
  const res = await fetchExtended('/v1/policy/index', {
    method: 'POST',
    credentials: 'include',
    body: convertFormData(policeCheckParams),
  });

  const result = await res.json();

  return result as IPolicyInfo;
};
